<template>
    <div class="clearfix w980">
        <div class="v100 weizhi fs12">
            首页 - 产品 - 锁大师</div>
        <product-menu now="onelocker" />
        <div class="v100 bigimg mt20">
            <img alt="锁大师" src="@/assets/images/onelocker_banner.jpg" />
            <div class="brand">
				<img src="@/assets/images/onelocker_banner.jpg" alt="锁大师" height="75" width="121" />
			</div>
            <h1 style="display:block;position:absolute;left:-5999px">锁大师</h1>
        </div>
        <div class="v100 gongneng">
            <dl>
                <img alt="极致保护，手机一键加密" class="fl" src="@/assets/images/onelocker_1.jpg" />
                <dt class="fr">极致保护，手机一键加密</dt>
                <dd class="fr">
                    手机软件一键加锁，从此不用担心隐私泄露</dd>
            </dl>
            <dl>
                <img alt="便捷生活，加锁解密轻松自如" class="fr" src="@/assets/images/onelocker_2.jpg" />
                <dt class="fl">便捷生活，加锁解密轻松自如</dt>
                <dd class="fl">
                    精确识别，瞬间还原，一触即开，前锁未有</dd>
            </dl>
            <dl>
                <img alt="更安全的手机加密，专业防破解" class="fl" src="@/assets/images/onelocker_3.jpg" />
                <dt class="fr">更安全的手机加密，专业防破解</dt>
                <dd class="fr">
                    保护你手机中的小秘密与大故事，图片视频“有”处可藏</dd>
            </dl>
            <dl>
                <img alt="小而美，专注手机加密防盗" class="fr" src="@/assets/images/onelocker_4.jpg" />
                <dt class="fl">小而美，专注手机加密防盗</dt>
                <dd class="fl">
                    低内存占用高安全性能，一上手就爱不释手</dd>
            </dl>
        </div>
    </div>
</template>

<script>
import ProductMenu from "@/components/function/ProductMenu";
export default {
  name: "onelocker",
  components: {
    ProductMenu
  }
};
</script>



// WEBPACK FOOTER //
// src/components/function/onelocker.vue